var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"menu-header-main absolute left-0 top-0 z-20 w-full"},[_c('div',{staticClass:"container-fluid px-5 flex items-center justify-between py-space1"},[_c('Logo'),_c('Navbar'),_c('RightSideMenu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }